import { formatDateTime } from '../common/utilities';
import styled from 'styled-components';
interface Props {
    isCustomer: boolean;
}

const MessageBox = styled.div<Props>`
    display: flex;
    flex-direction: ${props => props.isCustomer ? "row" : "row-reverse"};
    margin: 10px;
    .adjuster{ 
        max-width:70%;
        .message{
            background-color: #d9eaf7;   
        }
    }
    .customer{
        max-width:70%;
        .message{
            background-color: #c4c4c4;
        }
    }
    .message{
        border-radius: 8px;
        padding: 10px;
    }
    
`;

export default function Message(props: any) {
    const { message, createdTime, contentType, from } = props.message;
    let isCustomer = from.name.includes("+1");
    let [formattedMessage, senderName] = message.split("\n");

    function getFormattedMessage(text: string) {
        var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig;
        let msg = text.replace(urlRegex, function (url: any) {
            return '<a href="' + url + '" target="_blank">' + url + '</a>';
        });
        return msg + "<br/>" + (senderName ? senderName : "");
    }
    return (
        <MessageBox isCustomer={isCustomer}>
            <div className={isCustomer ? "customer" : "adjuster"}>
                <div style={{ fontSize: 12 }}>
                    {formatDateTime(createdTime) + ", " + from.name}
                </div>
                <div className="content">
                    {contentType?.includes("image")
                        && <img
                            src={message}
                            alt={message}
                            style={{ maxWidth: "60%" }}
                        />
                    }
                    {contentType?.includes("video") &&
                        <>
                            <video
                                src={message}
                                width={320}
                                height={240}
                                controls>
                            </video>
                            <p style={{ marginBottom: 10 }}>
                                <a href={message}>Download the video file</a>.
                            </p>
                        </>
                    }
                    {!contentType &&
                        <div className="message" dangerouslySetInnerHTML={{ __html: getFormattedMessage(formattedMessage) }} >
                        </div>
                    }
                </div >
            </div>
        </MessageBox >
    )
}
